import { Link } from "react-router-dom";
import Layout from "../common/Layout";
import { usePageMeta } from "../common/usePageMeta";

export default function NotFoundPage() {
  usePageMeta({ title: "Page not found | TearDrop Hydro", path: "/404", noindex: true });

  return (
    <Layout>
      <div className="container section" style={{ textAlign: "center", padding: "var(--s-10) var(--s-5)" }}>
        <div style={{ fontSize: 56, marginBottom: "var(--s-3)" }} aria-hidden="true">🥬</div>
        <h1 className="h2" style={{ marginBottom: "var(--s-2)" }}>That page has bolted.</h1>
        <p className="muted" style={{ maxWidth: 420, margin: "0 auto var(--s-6)" }}>
          The link you followed doesn't exist (or got harvested). Here's where you probably wanted to go:
        </p>
        <div style={{ display: "flex", gap: "var(--s-3)", justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/browse-products" className="btn btn-primary">Browse today's harvest</Link>
          <Link to="/" className="btn btn-ghost">Back to the homepage</Link>
        </div>
      </div>
    </Layout>
  );
}
